<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="设备SN">
          <Input placeholder="请输入" v-model="table.search.clientSN"></Input>
        </FormItem>
        <!-- <FormItem label="服务名">
          <Input placeholder="请输入" v-model="table.search.ServiceName"></Input>
        </FormItem> -->
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <!-- <Button class="mr-3" type="primary" @click="addModal = true">新增</Button> -->
      </div>

    </div>

    <Row :gutter="16">
      <Col span="20">
        <!--主-->
        <DataTable
          ref="dataTable"
          :reduceHeight="245"
          :columns="table.columns"
          :apiUrl="table.apiUrl"
          :search="table.search"
          @onRowClick="onRowClick"
        ></DataTable>
      </Col>
      <!-- <Col span="14"> -->
      <Modal
        v-model="xmllistModal"
        title="新增"
        width = "1000px"
      >
        <!--从-->
        <!-- <DataTable
          v-if="isShowDataTable2"
          class="mb-5"
          ref="dataTable2"
          :columns="table2.columns"
          :apiUrl="table2.apiUrl"
          :search="table2.search"
        ></DataTable> -->
        <xmllist v-if="xmllistModal" :clientSN="clientSN"></xmllist>
        </Modal>
      <!-- </Col> -->
    </Row>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientXmladd @close="addModal = false" @loadData="search"></clientXmladd>
    </Modal>

    <!--编辑-->
    <Modal
      v-model="editModal"
      title="编辑"
      :footer-hide="true"
      
      :closable="false"
    >
      <clientXmledit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></clientXmledit>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import clientXmladd from "../clientXml/add.vue";
import clientXmledit from "../clientXml/edit.vue";
import xmllist from "../clientXml/xmllist.vue";

export default {
  components: {
    DataTable,
    clientXmladd,
    clientXmledit,
    xmllist,
  },

  data: function () {
    return {
      show_fuwu:false,
      isShowDataTable2: false,
      parmTitleSelect: [],
      currentData: {},
      addModal: false,
      editModal: false,
      xmllistModal: false,
      clientSN: "",
      table: {
        columns: [
          { title: "设备SN", key: "clientSN", width: "250px" },
          { title: "设备名称", key: "clientName" },
        ],
        apiUrl: "clientDetail/getList",
        search: {
          clientSN: "",
        },
      },
      table2: {
        columns: [
          {
            title: "服务名",
            key: "parmTitle",
            width: "180px",
            render: (h, params) =>
              h("span", {}, this.findServerName(params.row.parmTitle)),
          },
          { title: "类型", key: "parmType", width: "60px" },
          // { title: "键", key: "parmName" },
          { title: "值", key: "parmValue", tooltip: true },
          {
            title: "启用状态",
            key: "statusName",
          },
          {
            title: "更新状态",
            key: "updateName",
          },
          {
            title: "操作",
            width: "280px",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "warning",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.clientParameterID);
                      },
                    },
                  },
                  "删除"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.status == 0 ? "error" : "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.SwitchState(params.row, params.row.status ^ 1);
                      },
                    },
                  },
                  params.row.status == 0 ? "关闭" : "启用"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.status == 0 ? "error" : "primary",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.SwitchUpdate(params.row, params.row.isUpdate ^ 1);
                      },
                    },
                  },
                  params.row.isUpdate == 0 ? "设置已更新" : "设置未更新"
                ),
              ]);
            },
          },
        ],
        apiUrl: "clientXml/getList",
        search: {
          clientSN: "",
          ServiceName: "",
        },
      },
    };
  },

  created() {
    this.getXmlServiceNameList();
  },
  activated(){
    this.search()
  },
  methods: {
    findServerName(code) {
      var obj = this.parmTitleSelect.find((p) => p.dictionaryCode == code);
      if (obj) {
        return obj.dictionaryValue;
      } else {
        return "";
      }
    },
    ConvertStatus(code) {
      switch (code) {
        case 0:
          return "启动";
        case 1:
          return "关闭";
        // case 2:
        //   return "重启";
        default:
          return "启动";
      }
    },

    search: function () {
      this.$refs.dataTable.initload();
    },
    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
      let name = this.currentData.parmTitle;
      this.currentData.parmTitle = this.findServerName(name);
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "是否删除这条配置项？",
        mask: false,
        onOk: () => {
          this.$api.post(`/clientXml/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    getXmlServiceNameList() {
      this.$common.getDictionaryByCode("9001").then((data) => {
        this.parmTitleSelect = data;
      });
    },

    onRowClick(data) {
      // this.isShowDataTable2 = true;
      // this.table2.search.clientSN = data.clientSN;
      this.xmllistModal = true;
      this.clientSN = data.clientSN;
     // if (this.$refs.dataTable2) this.$refs.dataTable2.initload();
    },
    SwitchState(data, status) {
      var parm = {
        ClientParameterID: data.clientParameterID,
        Status: status,
      };

      this.$api.post(`/clientXml/SwitchState`, parm).then((rsp) => {
        if (rsp.statusCode == 200) {
          this.$Message.success(rsp.msg);
          this.table2.search.clientSN = data.clientSN;
          if (this.$refs.dataTable2) this.$refs.dataTable2.initload();
        } else {
          this.$Message.success(rsp.msg);
        }
      });
    },
    SwitchUpdate(data, status) {
      var parm = {
        ClientParameterID: data.clientParameterID,
        Status: status,
      };

      this.$api.post(`/clientXml/SwitchUpdate`, parm).then((rsp) => {
        if (rsp.statusCode == 200) {
          this.$Message.success(rsp.msg);
          this.table2.search.clientSN = data.clientSN;
          if (this.$refs.dataTable2) this.$refs.dataTable2.initload();
        } else {
          this.$Message.success(rsp.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
</style>